exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#entreprises-table>tbody>tr>td{vertical-align:middle}", ""]);

// exports
